module.exports = __webpack_public_path__ + "img/news_4.8b42458f.png";